import React from "react";

const Compass = () => (
  <svg
    className="compass-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 80 80"
  >
    <title>Asset 1</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="cls-1"
          d="M40,0A40,40,0,1,0,80,40,40,40,0,0,0,40,0Zm0,76A36,36,0,1,1,76,40,36,36,0,0,1,40,76Zm0-66A30,30,0,1,0,70,40,30,30,0,0,0,40,10Zm0,56A26,26,0,1,1,66,40,26,26,0,0,1,40,66ZM54.21,23.16l-21,9a2,2,0,0,0-1,1.05l-9,21a2,2,0,0,0,2.63,2.63l21-9a2,2,0,0,0,1-1.05l9-21a2,2,0,0,0-2.63-2.62ZM34.67,37.5l7.82,7.82L28.81,51.19Zm10.65,5L37.5,34.68l13.69-5.87Z"
        />
      </g>
    </g>
  </svg>
);

export default Compass;
